function initSaturnBoxSection() {
    const saturnStepDuration = 12;
    const saturnBox = document.querySelector('.saturn-box');
    const { clientWidth } = document.documentElement;
    if (!saturnBox) return;
    const setSvgTimerElement = () => {
        const svgElement = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'svg'
        );
        svgElement.classList.add('saturn-box__circle__timer');
        svgElement.setAttribute('width', '36');
        svgElement.setAttribute('height', '36');
        svgElement.setAttribute('viewBox', '0 0 36 36');
        svgElement.setAttribute('fill', 'none');
        svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svgElement.style.setProperty(
            '--s-step-duration',
            `${saturnStepDuration}s`
        );

        const circleElement = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'circle'
        );
        circleElement.setAttribute('cx', '18');
        circleElement.setAttribute('cy', '18');
        circleElement.setAttribute('r', '16');
        circleElement.setAttribute('stroke', 'white');
        circleElement.setAttribute('stroke-width', '4');

        svgElement.appendChild(circleElement);
        return svgElement;
    };

    function throttle(func, limit) {
        let lastFunc;
        let lastRan;
        return function (...args) {
            const context = this;
            if (!lastRan) {
                func.apply(context, args);
                lastRan = Date.now();
            } else {
                clearTimeout(lastFunc);
                lastFunc = setTimeout(function () {
                    if (Date.now() - lastRan >= limit) {
                        func.apply(context, args);
                        lastRan = Date.now();
                    }
                }, limit - (Date.now() - lastRan));
            }
        };
    }

    function setLivePhoneContent(index) {
        const phoneContent = saturnBox.querySelector('.phone-content');
        const textBoxes = saturnBox.querySelectorAll('.saturn-box__text-box');

        window.requestAnimationFrame(() => {
            if (phoneContent) {
                if (!index) {
                    phoneContent.classList.remove('phone-content--active');
                } else {
                    phoneContent.classList.add('phone-content--active');
                    const phoneVideo = phoneContent.querySelector(
                        '.phone-content__video'
                    );
                    phoneVideo.setAttribute(
                        'src',
                        `/wp-content/themes/wp-group107/src/images/videos/saturn_${index}.mp4`
                    );
                    phoneVideo.play();
                }
            }

            if (textBoxes) {
                textBoxes.forEach((textBox) =>
                    textBox.classList.remove('saturn-box__text-box--active')
                );
                textBoxes[index].classList.add('saturn-box__text-box--active');
            }
        });
    }

    function initMobileNavigation() {
        const mobileNavContainer = saturnBox.querySelector(
            '.saturn-navigation-container'
        );

        if (mobileNavContainer) {
            const mobileNavButtons = mobileNavContainer.querySelectorAll(
                '.saturn-navigation-container__item'
            );

            if (mobileNavButtons.length) {
                let skipScrollListener = false;
                const updateActiveButtonOnScroll = () => {
                    if (skipScrollListener) return;

                    const containerWidth = mobileNavContainer.clientWidth;
                    const containerCenter =
                        mobileNavContainer.scrollLeft + containerWidth / 2;

                    mobileNavButtons.forEach((navBtn, index) => {
                        const buttonWidth = navBtn.clientWidth;
                        const buttonCenter =
                            navBtn.offsetLeft + buttonWidth / 2;

                        const distanceFromCenter = Math.abs(
                            buttonCenter - containerCenter
                        );

                        if (distanceFromCenter <= containerWidth * 0.25) {
                            if (
                                !navBtn.classList.contains(
                                    'saturn-navigation-container__item--active'
                                )
                            ) {
                                mobileNavButtons.forEach((btn) =>
                                    btn.classList.remove(
                                        'saturn-navigation-container__item--active'
                                    )
                                );
                                navBtn.classList.add(
                                    'saturn-navigation-container__item--active'
                                );
                                setLivePhoneContent(index);
                            }
                        }
                    });
                };

                mobileNavButtons.forEach((navBtn, index) => {
                    navBtn.addEventListener(
                        'click',
                        () => {
                            if (
                                !navBtn.classList.contains(
                                    'saturn-navigation-container__item--active'
                                )
                            ) {
                                skipScrollListener = true;
                                const containerWidth =
                                    mobileNavContainer.clientWidth;
                                const buttonWidth = navBtn.clientWidth;
                                const buttonOffsetLeft = navBtn.offsetLeft;
                                const scrollPosition =
                                    buttonOffsetLeft -
                                    containerWidth / 2 +
                                    buttonWidth / 2;

                                setLivePhoneContent(index);
                                mobileNavButtons.forEach((btn) =>
                                    btn.classList.remove(
                                        'saturn-navigation-container__item--active'
                                    )
                                );
                                navBtn.classList.add(
                                    'saturn-navigation-container__item--active'
                                );
                                mobileNavContainer.scrollTo({
                                    left: scrollPosition,
                                    behavior: 'smooth',
                                });
                                setTimeout(
                                    () => (skipScrollListener = false),
                                    350
                                );
                            }
                        },
                        { passive: false }
                    );
                });

                if (clientWidth < 524) {
                    mobileNavContainer.addEventListener(
                        'scroll',
                        throttle(updateActiveButtonOnScroll, 300),
                        { passive: false }
                    );
                }
            }
        }
    }

    function initDesktopNavigation() {
        let stepTimeOut = null;
        const desktopNavButtons = saturnBox.querySelectorAll(
            '.saturn-box__circle__step'
        );

        if (desktopNavButtons && desktopNavButtons.length) {
            desktopNavButtons.forEach((navBtn, index) => {
                navBtn.appendChild(setSvgTimerElement());
                navBtn.addEventListener(
                    'mouseover',
                    () => {
                        if (
                            navBtn.classList.contains(
                                'saturn-box__circle__step--active'
                            )
                        )
                            return;

                        clearTimeout(stepTimeOut);
                        desktopNavButtons.forEach((btn) => {
                            btn.classList.remove(
                                'saturn-box__circle__step--active'
                            );
                            btn.classList.add(
                                'saturn-box__circle__step--inactive'
                            );
                        });

                        setLivePhoneContent(index + 1);
                        navBtn.classList.add(
                            'saturn-box__circle__step--active'
                        );
                        navBtn.classList.remove(
                            'saturn-box__circle__step--inactive'
                        );

                        stepTimeOut = setTimeout(() => {
                            desktopNavButtons.forEach((btn) => {
                                setLivePhoneContent(0);
                                btn.classList.remove(
                                    'saturn-box__circle__step--active'
                                );
                                btn.classList.remove(
                                    'saturn-box__circle__step--inactive'
                                );
                            });
                        }, saturnStepDuration * 1000);
                    },
                    { passive: false }
                );
            });
        }
    }

    if (clientWidth <= 1024) {
        initMobileNavigation();
    } else {
        initDesktopNavigation();
    }
}

// Initialize the testimonials slider when the document is fully loaded
document.defaultView.addEventListener(
    'DOMContentLoaded',
    initSaturnBoxSection,
    false
);
